var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',_vm._g(_vm._b({staticClass:"old-form-input cursor-pointer border border-gray-300 disabled:bg-gray-100",class:{
    readonly: _vm.$attrs.readonly,
    'border-red-500 bg-red-100': !_vm.isValid
  },attrs:{"disabled":_vm.inputDisabled}},'select',_vm.$attrs,false),_vm.listeners),_vm._l((_vm.normalizedOptions),function(o,i){return _c('option',{key:i,attrs:{"disabled":o.disabled},domProps:{"value":o.value}},[_vm._v(" "+_vm._s(o[_vm.itemTextProperty])+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }